module.exports = __webpack_public_path__ + "static/media/result-0-zh-HK.66dbc591.png";